import * as yup from 'yup'
import { t } from '@lingui/macro'
export const forgotPasswordFormValidationSchema = () =>
  yup.object({
    userEmail: yup
      .string()
      .email(t`Please enter a valid email`)
      .required(t`Please enter your accounts email`)
  })
